import { logger } from '@zep/core-logger';

import { type UserInfo } from '@/types/UserInfo';

import { createLoggerUserContext } from './createLoggerUserContext';

export const setLogUserInfo = (user: UserInfo | null) => {
  if (!user) {
    handleLogoutState();
    return;
  }

  setLoggerUserContext(user);
};

// 로그아웃 상태 처리
// TODO(logger-integration): 로그아웃 시 PostHog distinct_id 초기화가 누락되어 있다.
// main 브랜치에도 부재했던 gap — 이전 사용자의 distinct_id가 잔류해 익명 활동이 잘못 집계될 수 있다.
// 후속 PR에서 `logger.reset()` 같은 공용 API를 ZEPLogger에 추가해 posthog.reset()을 fan-out 하는 방식으로 해결 예정.
// 참고: docs/logger-integration-followup-plan.md, 설계 초안 /Users/zep/.claude/plans/radiant-snacking-parasol.md
const handleLogoutState = () => {
  logger.clearUserContext({ IS_LOGIN: false });
};

const setLoggerUserContext = (user: UserInfo) => {
  logger.setUserContext(createLoggerUserContext(user));
};
